import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  calculateShiftAndPunchDifferences,
  calculateFinePerMinute,
} from "../../utils/helper";
import StatusButton from "./StatusButton";
import FineModal from "./FineModal";
import OvertimeModal from "./OvertimeModal";
import PresentModal from "../Admin_Panel/AttendanceSummary/PresentModal";
import HalfDay from "../Admin_Panel/AttendanceSummary/HalfDayModal";
import PresentConfirmationModal from "../Admin_Panel/AttendanceSummary/PresentConfirmationModal";
import HalfDayConfirmationModal from "../Admin_Panel/AttendanceSummary/HalfDayConfirmationModal";
import Cookies from "js-cookie";
import { useGlobalContext } from "../../Context/GlobalContext";
import PaidLeaveConfirmationModal from "../Admin_Panel/AttendanceSummary/PaidLeaveModal";
import AbsentModal from "../Admin_Panel/AttendanceSummary/AbsentModal";

const AttendanceRecord = ({
  item,
  summaryDate,
  staffs,
  setSelectedStaff,
  fetchAttendanceDetail,
}) => {
  console.log(item)
  const { openToast, baseUrl } = useGlobalContext();
  const [isOpenFine, setIsOpenFine] = useState(false);
  const [isOpenOvertime, setIsOpenOvertime] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [staffId, setStaffId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shiftDetail, setShiftDetail] = useState("")
  console.log(shiftDetail)
  const handleFineClick = () => {
    setIsOpenFine(true);
  };

  const handleOvertimeClick = () => {
    setIsOpenOvertime(true);
  };

  const calcTimeDiff = (item) => {
    const punchInTime = item?.punchRecord?.[0]?.punchIn?.punchInTime;
    const punchOutTime = item?.punchRecord?.[0]?.punchOut?.punchOutTime;

    if (punchInTime && punchOutTime) {
      const inTime = new Date(punchInTime);
      const outTime = new Date(punchOutTime);

      // Calculate time difference in milliseconds
      const diffInMs = outTime - inTime;

      // Convert milliseconds to hours and minutes
      const hours = Math.floor(diffInMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

      // Format the difference as "HH:mm"
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    } else {
      return "0:00"; // Default if times are not available
    }
  };

  const res = calculateShiftAndPunchDifferences(
    item?.punchRecord[0]?.shift?.shiftStartTime,
    item?.punchRecord[0]?.punchIn?.punchInTime
  );
  const punchOutFine = calculateShiftAndPunchDifferences(
    item?.punchRecord[0]?.shift?.shiftEndTime,
    item?.punchRecord[0]?.punchOut?.punchOutTime
  );
  async function confirmation() {
    setLoading(true);
    try {
      if (selectedStatus == "") {
        openToast("Please Select Status", "error");
        return;
      }

      const result = await fetch(baseUrl + `attendance/status/${staffId.id}`, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ status: selectedStatus }),
      });
      if (result.status == 200) {
        openToast("Updated Status Successfully", "success");
        fetchAttendanceDetail();
        setSelectedStatus("");
        setStaffId(null);
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
      openToast("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  }


  return (
    <>
      {
        staffId &&
        selectedStatus == "PRESENT" &&
        <PresentModal
          selectedStatus={selectedStatus}
          setStatus={setSelectedStatus}
          staffData={staffId}
          summaryDate={summaryDate}
          setStaffId={setStaffId}
          fetchAttendanceDetail={fetchAttendanceDetail}
          shiftDetail={shiftDetail}
        />
      }
      {staffId &&
        selectedStatus == "HALFDAY" &&
        <HalfDay
          setStatus={setSelectedStatus}
          selectedStatus={selectedStatus}
          staffData={staffId}
          summaryDate={summaryDate}
          setStaffId={setStaffId}
          fetchAttendance={fetchAttendanceDetail}
          shiftDetail={shiftDetail}
        />
      }

      <PaidLeaveConfirmationModal
        setStatus={setSelectedStatus}
        status={selectedStatus}
        confirmation={confirmation}
        setStaffId={setStaffId}
        staffId={staffId}
        fetchAttendance={fetchAttendanceDetail}
        summaryDate={summaryDate}
      />
      <AbsentModal
        setStatus={setSelectedStatus}
        status={selectedStatus}
        confirmation={confirmation}
        setStaffId={setStaffId}
        staffId={staffId}
        fetchAttendance={fetchAttendanceDetail}
      />
      <div className="shadow shadow-cs p-[20px] rounded-md">
        <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start md:items-start gap-4 md:gap-0 lg:gap-0 xl:gap-0">
          <div>
            <Link
              to={"/personal-detail/" + item?.staffDetails?.User?.id}
              onClick={() => {
                setSelectedStaff({
                  ...item?.punchRecord?.staff.User,
                  staffDetails: item?.punchRecord?.staff,
                });
              }}
              className="font-normal text-[#27004a] text-[16px] whitespace-nowrap"
            >
              {item?.staffDetails?.User?.name}
            </Link>
            <p className="font-normal text-[#9d9d9d] text-[14px] whitespace-nowrap">
              {calcTimeDiff(item)} Hrs
            </p>
            <p className="font-normal text-[#9d9d9d] text-[14px] whitespace-nowrap">
              {item?.punchRecord?.[0]?.shift?.shiftName} (
              {item?.punchRecord?.[0]?.punchIn?.punchInTime && item?.punchRecord?.[0]?.status == "PRESENT"
                ? new Date(
                  item.punchRecord?.[0].punchIn.punchInTime
                ).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                : "N/A"}
              -{" "}
              {item?.punchRecord?.[0]?.punchOut?.punchOutTime && item?.punchRecord?.[0]?.status == "PRESENT"
                ? new Date(
                  item?.punchRecord?.[0]?.punchOut?.punchOutTime
                ).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                : "N/A"}
              )
            </p>
            <p className="text-[14px] text-[#9d9d9d] whitespace-nowrap">
              Status : {item?.punchRecord?.[0]?.isApproved ? "Approved" : "Not Approved"}
            </p>
            <p className="text-[14px] text-[red]">
              {item?.punchRecord?.[0]?.status}
            </p>
          </div>

          <div className="flex flex-row md:flex-col lg:flex-col xl:flex-col justify-between md:justify-start lg:justify-start xl:justify-start gap-[18px] w-full set-workd">
            <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col md:justify-end lg:justify-end xl:justify-end gap-[20px] w-[50%] md:w-full xl:w-full">
              <StatusButton
                status="PRESENT"
                currentStatus={item?.punchRecord?.[0]?.status}
                onClick={() => {
                  setSelectedStatus("PRESENT");
                  setStaffId(item);
                }}
                punchInTime={item?.punchRecord?.[0]?.punchIn?.punchInTime}
                punchOutTime={item?.punchRecord?.[0]?.punchOut?.punchOutTime}
              />
              <StatusButton
                status="HALFDAY"
                currentStatus={item?.punchRecord[0]?.status}
                onClick={() => {
                  setSelectedStatus("HALFDAY");
                  setStaffId(item);
                }}
                punchInTime={item?.punchRecord[0]?.punchIn?.punchInTime}
                punchOutTime={item?.punchRecord[0]?.punchOut?.punchOutTime}
              />
              <button

                onClick={() => {
                  if (item?.punchRecord[0]?.status !== "PRESENT" && item?.punchRecord[0]?.status !== "HALFDAY") {
                    openToast("You can't apply fine without present or halfday", "warning");
                  }
                  else {
                    handleFineClick();
                  }
                }}
                className="bg-[white] shadow px-6 py-3 rounded-md focus:outline-none w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[#27004a] text-[14px] whitespace-nowrap btns"
              >
                F I Fine
              </button>
            </div>

            <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col md:justify-end lg:justify-end xl:justify-end gap-[20px] w-[50%] md:w-full xl:w-full">
              <button
                onClick={() => {
                  if (item?.punchRecord[0]?.status !== "PRESENT" && item?.punchRecord[0]?.status !== "HALFDAY") {
                    openToast("You can't apply overtime without present or halfday", "warning");
                  }
                  else {
                    handleOvertimeClick();
                  }
                }}
                className="bg-[#fff] shadow-md px-6 py-3 rounded-md focus:outline-none w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[#000] text-[14px] whitespace-nowrap btns"
              >
                OT I Overtime
              </button>
              <StatusButton
                status="PAIDLEAVE"
                currentStatus={item?.punchRecord[0]?.status}
                onClick={() => {
                  setSelectedStatus("PAIDLEAVE");
                  setStaffId(item);
                }}
              />
              <StatusButton
                status="ABSENT"
                currentStatus={item?.punchRecord[0]?.status}
                onClick={() => {
                  setSelectedStatus("ABSENT");
                  setStaffId(item);
                }}
              />
            </div>
          </div>
        </div>

        {isOpenFine && (
          <FineModal
            item={item}
            staffs={staffs}
            baseUrl={baseUrl}
            openToast={openToast}
            onClose={() => setIsOpenFine(false)}
            res={res}
            punchOutFine={punchOutFine}
            fetchAttendance={fetchAttendanceDetail}
          />
        )}

        {isOpenOvertime && (
          <OvertimeModal
            item={item}
            staffs={staffs}
            baseUrl={baseUrl}
            openToast={openToast}
            onClose={() => setIsOpenOvertime(false)}
            fetchAttendance={fetchAttendanceDetail}
          />
        )}
      </div>
    </>
  );
};

export default AttendanceRecord;